"use strict";
/**
 * @module "ethpm/config"
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.load = void 0;
const v3 = __importStar(require("../manifests/v3"));
const ipfs = __importStar(require("../storage/ipfs"));
const installer = __importStar(require("../installer/truffle"));
const registries = __importStar(require("../registries/web3"));
const originalRequire = require("original-require");
const cleanPackagePath = (plugin) => plugin.replace(/^ethpm\//, "../");
// This is required to enable webpack to include these modules when bundling
const mappings = {
    "ethpm/manifests/v3": v3,
    "ethpm/storage/ipfs": ipfs,
    "ethpm/installer/truffle": installer,
    "ethpm/registries/web3": registries,
};
function load(plugin) {
    const required = (typeof plugin === 'string')
        ? plugin.startsWith("ethpm/")
            ? mappings[plugin]
            : originalRequire(plugin)
        : (typeof plugin === 'function')
            ? plugin
            : (typeof plugin === 'object' && plugin.default)
                ? plugin.default : undefined;
    // HACK check for .default
    const connector = (typeof required === 'object' && required.default)
        ? required.default
        : required;
    return new connector();
}
exports.load = load;
